export default __webpack_public_path__ + "static/media/anomaliasidentificadas.ba1d954d.svg";